var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.555664,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#49AF47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5257 24.08C29.2857 26.75 27.3557 28.5 24.5557 28.5H15.5557C12.7957 28.5 10.5557 26.26 10.5557 23.5V16.5C10.5557 13.78 12.1957 11.88 14.7457 11.56C15.0057 11.52 15.2757 11.5 15.5557 11.5H24.5557C24.8157 11.5 25.0657 11.51 25.3057 11.55C27.6957 11.83 29.3157 13.5 29.5257 15.92C29.5557 16.21 29.3157 16.45 29.0257 16.45H27.4757C26.5157 16.45 25.6257 16.82 24.9857 17.48C24.2257 18.22 23.8457 19.26 23.9357 20.3C24.0957 22.12 25.6957 23.55 27.5957 23.55H29.0257C29.3157 23.55 29.5557 23.79 29.5257 24.08Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5559 18.97V21.03C30.5559 21.58 30.1159 22.03 29.5559 22.05H27.5959C26.5159 22.05 25.5259 21.26 25.4359 20.18C25.3759 19.55 25.6159 18.96 26.0359 18.55C26.4059 18.17 26.9159 17.95 27.4759 17.95H29.5559C30.1159 17.97 30.5559 18.42 30.5559 18.97Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceIcon);
export default __webpack_public_path__ + "static/media/balance_icon.b18c5969ffc1ff580d631d01a1032f72.svg";
export { ForwardRef as ReactComponent };